import dayjs from "dayjs";
import { parseDate } from "helpers/date";
import { Label } from "layout/typography/Label";
import { Button } from "primereact/button";
import { Calendar, CalendarValueType } from "primereact/calendar";
import { useState, useCallback } from "react";
import { useGetPaidOrdersReportQuery } from "store/queries/dashboard";

export function PaidOrdersDownload({ accountId }: { accountId?: string }) {
  const startOfMonth = dayjs().startOf("month").toDate();
  const today = dayjs().toDate();
  const [paidDate, setPaidDate] = useState<Date[]>([startOfMonth, today]);

  const { data: paidOrdersData, isFetching } = useGetPaidOrdersReportQuery(
    {
      accountId: accountId!,
      paidDate: (paidDate || [])
        .filter((date) => date != null)
        .map((date) =>
          dayjs.utc(date.toISOString()).startOf("day").toISOString()
        ),
    },
    { skip: !accountId }
  );

  const handleOnChangePaidDateFilter = useCallback(
    (e: { value: CalendarValueType }) => {
      setPaidDate(e.value as Date[]);
    },
    []
  );

  const convertDataToCSV = (data: any): string => {
    if (!data || !data.data || !data.data.length) return "";
    const headers = Object.keys(data.data[0]).join(",");
    const rows = data.data.map((row: any) => Object.values(row).join(","));
    return [headers, ...rows].join("\n");
  };

  const downloadPaidOrdersCSV = () => {
    if (
      !paidOrdersData ||
      !paidOrdersData.data ||
      !paidOrdersData.data.length
    ) {
      alert("No data available to download.");
      return;
    }
    const changedData = paidOrdersData.data.map((item: any) => {
      return {
        ...item,
        order_create_date: parseDate(item.order_create_date, false, true),
        paid_date: parseDate(item.paid_date, false, true),
        service_date: parseDate(item.service_date, false, false),
      };
    });
    const csvString = convertDataToCSV({ data: changedData });
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `paid_orders_report_${new Date().getTime()}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="flex gap-2 align-items-end flex-wrap">
      <div
        className="flex flex-column gap-2 w-fit"
        style={{ minWidth: "250px" }}
      >
        <Label htmlFor="from">Estimate Paid Date</Label>
        <Calendar
          data-testid="range_calendar"
          selectionMode="range"
          placeholder="Estimate Paid Date"
          value={paidDate}
          onChange={handleOnChangePaidDateFilter}
        />
      </div>
      <Button
        label="Download"
        type="button"
        onClick={downloadPaidOrdersCSV}
        className="h-fit"
        icon="pi pi-download"
        loading={isFetching}
        disabled={isFetching}
      />
    </div>
  );
}
